<p-table [value]="projects"
         [rows]="100"
         [paginator]="true"
         [style]="{'margin-top':'10px'}"
         #table
         dataKey="roleGroup"
>
  <ng-template pTemplate="header">
    <tr style="white-space: nowrap;font-weight: bold">
      <th>Name</th>
      <th style="width:15em"></th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-item let-rowIndex="rowIndex">
    <tr>
      <td>
        {{item.name}}
      </td>
      <td>
        <button type="button"
                pButton
                class="risksponge-button"
                title="Edit user"
                icon="pi pi-trash"
                mwlConfirmationPopover [title]="'Delete Project'"
                [popoverMessage]="'This will result in permanently deleting all project data.  Do you wish to proceed?'"
                [appendToBody]="true"
                [confirmText]="'Yes'" [cancelText]="'No'" placement="left"
                (confirm)="delete(item.projectId)">
        </button>
      </td>
    </tr>
  </ng-template>
</p-table>
